import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'

import css from '../styles.css'

const ExtraQuestion = ({
  extraQuestion,
  onQuestionChange,
  extraQuestionIdx,
}) => (
  <div className={css.extraQuestionContainer}>
    {Object.keys(extraQuestion).map(field => (
      <Form.Item
        label={extraQuestion[field].label}
        key={field}
        className={css.extraQuestionField}
      >
        <Input
          name={field}
          onChange={e => onQuestionChange(e, extraQuestionIdx)}
          placeholder={extraQuestion[field].placeholder}
          value={extraQuestion[field].value}
        />
      </Form.Item>
    ))}
  </div>
)

ExtraQuestion.propTypes = {
  extraQuestion: PropTypes.object.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  extraQuestionIdx: PropTypes.number.isRequired,
}

export default ExtraQuestion



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/ExtraQuestions/ExtraQuestion.js